import * as types from "../constants/actionTypes";

export const videoVisitInitialState = {
    onTheFlyVisit: {
        isWaiting: false, visitSuccess: true, room: {}
    }
};

export default function videoVisitReducer(state = videoVisitInitialState, action) {
    switch (action.type) {
        case types.AMBULATORY_VIDEO_VISIT_SURVEY_REQUEST_PENDING:
            return { ...state, survey: { isWaiting: true, isSuccess: false, isFailure: false } };
        case types.AMBULATORY_VIDEO_VISIT_SURVEY_REQUEST_SUCCESS:
            return { ...state, survey: { isWaiting: false, isSuccess: true, isFailure: false } };
        case types.AMBULATORY_VIDEO_VISIT_SURVEY_REQUEST_FAILURE:
            return { ...state, survey: { isWaiting: false, isSuccess: false, isFailure: true } };

        case types.INSTADOC_PROVIDERS_START:
            return { ...state, providers: { isWaiting: true } };
        case types.INSTADOC_PROVIDERS_SUCCESS:
            return { ...state, providers: { isWaiting: false, list: action.list, header: action.header, error: null } };
        case types.INSTADOC_PROVIDERS_FAILURE:
            return { ...state, providers: { isWaiting: false, list: null, header: null, error: action.error } };

        case types.INSTADOC_PROVIDER_INFO_START:
            return { ...state, providerInfo: null, providerInfoLoading: true, providerInfoSuccess: null, providerInfoError: null };
        case types.INSTADOC_PROVIDER_INFO_SUCCESS:
            return { ...state, providerInfo: action.providerInfo, sdcAllowed: action.sdcAllowed, providerInfoLoading: false, providerInfoSuccess: true };
        case types.INSTADOC_PROVIDER_INFO_FAILURE:
            return { ...state, providerInfoLoading: false, providerInfoError: action.error, providerInfoSuccess: false };

        case types.IS_MOBILE_NUMBER:
            return { ...state, isMobileNumber: { ...state.isMobileNumber, ...action } };

        case types.SMS_VIDEO_VISIT_LINK:
            return { ...state, smsVideoVisitLink: { isWaiting: true, isSuccess: false, isFailure: false, room: action.room, mobileNumber: action.mobileNumber } };
        case types.SMS_VIDEO_VISIT_LINK_SUCCESS:
            return { ...state, smsVideoVisitLink: { isWaiting: false, isSuccess: true, isFailure: false, response: action.response } };
        case types.SMS_VIDEO_VISIT_LINK_FAILURE:
            return { ...state, smsVideoVisitLink: { isWaiting: false, isSuccess: false, isFailure: true, error: action.error } };

        case types.EMAIL_VIDEO_VISIT_LINK:
            return { ...state, emailVideoVisitLink: { isWaiting: true, isSuccess: false, isFailure: false, room: action.room, email: action.email } };
        case types.EMAIL_VIDEO_VISIT_LINK_SUCCESS:
            return { ...state, emailVideoVisitLink: { isWaiting: false, isSuccess: true, isFailure: false, response: action.response } };
        case types.EMAIL_VIDEO_VISIT_LINK_FAILURE:
            return { ...state, emailVideoVisitLink: { isWaiting: false, isSuccess: false, isFailure: true, error: action.error } };

        case types.SMS_VIDEO_VISIT_LINK_FOR_GUEST:
            return { ...state, smsVideoVisitLinkForGuest: { isWaiting: true, isSuccess: false, isFailure: false, room: action.room, mobileNumber: action.mobileNumber } };
        case types.SMS_VIDEO_VISIT_LINK_FOR_GUEST_SUCCESS:
            return { ...state, smsVideoVisitLinkForGuest: { isWaiting: false, isSuccess: true, isFailure: false, response: action.response } };
        case types.SMS_VIDEO_VISIT_LINK_FOR_GUEST_FAILURE:
            return { ...state, smsVideoVisitLinkForGuest: { isWaiting: false, isSuccess: false, isFailure: true, error: action.error } };

        case types.EMAIL_VIDEO_VISIT_LINK_FOR_GUEST:
            return { ...state, emailVideoVisitLinkForGuest: { isWaiting: true, isSuccess: false, isFailure: false, room: action.room, email: action.email } };
        case types.EMAIL_VIDEO_VISIT_LINK_FOR_GUEST_SUCCESS:
            return { ...state, emailVideoVisitLinkForGuest: { isWaiting: false, isSuccess: true, isFailure: false, response: action.response } };
        case types.EMAIL_VIDEO_VISIT_LINK_FOR_GUEST_FAILURE:
            return { ...state, emailVideoVisitLinkForGuest: { isWaiting: false, isSuccess: false, isFailure: true, error: action.error } };

        case types.CANCEL_VIDEO_VISIT_LINK:
            return { ...state, cancelVideoVisitLink: { isWaiting: true, isSuccess: false, isFailure: false, shareCode: action.shareCode } };
        case types.CANCEL_VIDEO_VISIT_LINK_SUCCESS:
            return { ...state, cancelVideoVisitLink: { isWaiting: false, isSuccess: true, isFailure: false } };
        case types.CANCEL_VIDEO_VISIT_LINK_FAILURE:
            return { ...state, cancelVideoVisitLink: { isWaiting: false, isSuccess: false, isFailure: true } };

        case types.VIDEO_VISIT_SHARE_LINK_HISTORY:
            return { ...state, shareLinkHistory: { ...state.shareLinkHistory, waitingGuestList: null, isWaiting: true, isSuccess: false, isFailure: false, room: action.room, email: action.email } };
        case types.VIDEO_VISIT_SHARE_LINK_HISTORY_SUCCESS:
            {
                const list = action.list ? action.list.reverse() : null;
                const waitingGuestList = list.filter(item => item.status === "GUEST_WAITING_FOR_APPROVAL" && item.token && item.token.participantRole && item.token.participantRole.toLowerCase() ==="guest");
                return { ...state, shareLinkHistory: { list: list, waitingGuestList: waitingGuestList, isWaiting: false, isSuccess: true, isFailure: false } };
            }
        case types.VIDEO_VISIT_SHARE_LINK_HISTORY_FAILURE:
            return { ...state, shareLinkHistory: { ...state.shareLinkHistory, waitingGuestList:null, isWaiting: false, isSuccess: false, isFailure: true } };
        case types.SET_GUEST_LINK_APPROVAL_STATUS:
            return { ...state, guestLinkApprovalStatus: { ...action.data } };
        case types.APPOINTMENT_HISTORY_PENDING:
            return {
                ...state, visitHistory: {isWaiting : true}}
        case types.APPOINTMENT_HISTORY_SUCCESS:
            return {
                ...state, visitHistory: { isWaiting: false, data: action.visits }
            }

        case types.CREATE_VIRTUAL_ROOM_PENDING:
            return {
                ...state,
                onTheFlyVisit: {
                    isWaiting: true
                }
            }

        case types.CREATE_VIRTUAL_ROOM_SUCCESS:
            return {
                ...state,
                onTheFlyVisit: {
                    isWaiting: false, visitSuccess: true, room: action.room
                }
            }
        case types.CREATE_VIRTUAL_ROOM_FAILURE:
            return {
                ...state,
                onTheFlyVisit: {
                    isWaiting: false, visitSuccess: false
                }
            }
        case types.SET_PARTICIPANTS:
            return { ...state, participants: action.participants };
        default:
            return { ...state };
    }
}